module.exports = __webpack_public_path__ + "img/35086f9.png";